import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { setLogout, setTokenKey, setRouter } from "common/src/utils/request";
import { globalStore, MutationTypes } from "./store";
import constants from "common/src/constants";

const app = createApp(App);

app.use(router);

app.use(globalStore);

app.mount("#app");

setLogout(() => {
  globalStore.commit(MutationTypes.RESET);
  router.push("/");
});

setTokenKey(constants.ACCESS_TOKEN_KEY_MYPAGE, constants.REFRESH_TOKEN_KEY_MYPAGE);

setRouter(router);
